import PlanEntryFinishedListResponse, {
  PlanEntryFinishedListResponseDataItem,
} from "../../../api/raily/plan-entry/finished-list/plan-entry-finished-list.response";
import PlanEntryFinishedList, {
  PlanEntryFinishedListItem,
} from "./plan-entry-finished-list";

const createDataItem = (
  responseItem: PlanEntryFinishedListResponseDataItem,
): PlanEntryFinishedListItem => {
  return {
    uuid: responseItem.id,
    driverName: responseItem.driverName,
    taxiCorporationName: responseItem.taxiName,
    routeAddresses: responseItem.planEntryNodes,
    humanId: responseItem.humanId,
    startTime: responseItem.startTime,
    passengers: responseItem.involvedCargoLabels,
    cargoOrderHumanIds: responseItem.cargoOrderHumanIds,
  };
};

const createData = (
  responseData: PlanEntryFinishedListResponseDataItem[],
): PlanEntryFinishedListItem[] => {
  return responseData.map(createDataItem);
};

const create = (
  response: PlanEntryFinishedListResponse,
): PlanEntryFinishedList => {
  return {
    data: createData(response.data.data),
    totalCount: response.data.totalCount,
  };
};

const planEntryFinishedListFactory = {
  create,
};

export default planEntryFinishedListFactory;
